import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const DirectionLtr = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <g transform="translate(-28.768 -29)">
        <path d="M37,31a3,3,0,0,0,0,6v6h1.5V32.5H40V43h1.5V32.5H43V31Zm-6,8.251,3-3-3-3Z" />
      </g>
    </svg>
  );
};

DirectionLtr.displayName = 'DirectionLtr';
